import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessCapacityCustomEmbedRoute: InvariantJiraRoute = {
	name: 'classic-business-capacity-custom-embed',
	exact: true,
	path: '/jira/core/projects/:projectKey/capacity/:itemId/embed',
};
